export const FORM_RULES = {
  firstName: {
    presence: true,
  },
  lastName: {
    presence: true,
  },
  email: {
    presence: true,
    email: true,
  },
  birthDay: {
    presence: true,
    exclusion: {
      within: { Day: "Day" },
      message: "is required",
    },
  },
  birthMonth: {
    presence: true,
    exclusion: {
      within: { Month: "Month" },
      message: "is required",
    },
  },
  birthYear: {
    presence: true,
    exclusion: {
      within: { Year: "Year" },
      message: "is required",
    },
  },
  emailConfirm: {
    presence: true,
    equality: "email",
  },
  password: {
    presence: true,
    length: {
      minimum: 8,
    },
  },
  passwordConfirm: {
    presence: true,
    equality: "password",
  },
  city: {
    presence: true,
  },
  address1: {
    presence: true,
  },
  postCode: {
    presence: true,
  },
  phonePrefix: {
    presence: true,
  },
  phone: {
    presence: true,
    numericality: true,
    length: {
      minimum: 7,
      maximum: 12,
    },
  },
};

export const CONFIRMATION_RULES = {
  acceptRules: {
    presence: {
      message: "^You need to accept Terms & Conditions",
    },
    inclusion: {
      within: [true],
      message: "^You need to accept Terms & Conditions",
    },
  },
};
